<template>
  <div style="background: #f7f7f7">
    <pcHeaders></pcHeaders>
    <div style="display: flex; justify-content: center">
      <div class="w">
        <div class="content">
          <div class="leftBox">
            <div class="photoBox">
              <div>
                <div class="center">
                  <img
                    style="width: 64px; height: 64px; border-radius: 50%"
                    :src="userAvatar"
                    v-if="userAvatar !== null && userAvatar !== ''"
                    alt="安全生产学习平台"
                  />
                  <img
                    style="width: 64px; height: 64px; border-radius: 50%"
                    src="../../assets/indexImg/avater.png"
                    v-else
                    alt="安全生产学习平台"
                  />
                </div>

                <div class="center" style="margin-top: 15px; align-items: center">
                  <div class="text">
                    {{ messageFromChild.realName }}
                  </div>
                  <div style="width: 16px; height: 16px" @click="handleInfo">
                    <img src="../../assets/images/update.png" alt="" style="width: 16px; height: 16px; cursor: pointer" />
                  </div>
                </div>
                <div class="btn_info" @click="handleInfo">去完善个人信息</div>
                <!-- <div class="yue" v-if="isMember!=='02'">
                  账户余额: {{ messageFromChild.balance }}
                </div> -->
                <!-- <div class="yue" style="" v-else>
                  年度会员
                </div> -->
              </div>
            </div>

            <div class="tabBox">
              <div :class="tabIndex == 1 ? 'optionBox active' : 'optionBox'" @click="nav(1)">
                <img v-if="tabIndex == 1" src="../../assets/images/zhuye1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/zhuye.png" alt="安全生产学习平台" />
                学习主页
              </div>
              <div :class="tabIndex == 4 ? 'optionBox active' : 'optionBox'" @click="nav(4)">
                <img v-if="tabIndex == 4" src="../../assets/images/zhanghao1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/zhanghao.png" alt="安全生产学习平台" />
                个人信息
              </div>
              <!-- <div :class="tabIndex == 8 ? 'optionBox active' : 'optionBox'" @click="nav(8)">
                <img v-if="tabIndex == 8" src="../../assets/images/zsslh.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/zssl.png" alt="安全生产学习平台" />
                课程学习
              </div> -->

              <!-- <div v-if="examShow">
                <div :class="tabIndex == 7  && examShow ? 'optionBox active' : 'optionBox'"
                     @click="nav(7)">
                  <img v-if="tabIndex == 7"
                       src="../../assets/images/exam1.png"
                       alt="安全生产学习平台">
                  <img v-else
                       src="../../assets/images/exam.png"
                       alt="安全生产学习平台">
                  我的考试
                </div>
              </div> -->

              <div :class="tabIndex == 3 ? 'optionBox active' : 'optionBox'" @click="nav(3)">
                <img v-if="tabIndex == 3" src="../../assets/images/dingdan1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/dingdan.png" alt="安全生产学习平台" />
                订单管理
              </div>
              <div :class="tabIndex == 7 ? 'optionBox active' : 'optionBox'" @click="nav(7)">
                <img v-if="tabIndex == 7" src="../../assets/images/tk1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/tk.png" alt="安全生产学习平台" />
                题库练习
              </div>
              <div :class="tabIndex == 10 ? 'optionBox active' : 'optionBox'" @click="nav(10)">
                <img v-if="tabIndex == 10" src="../../assets/images/mn1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/mn.png" alt="安全生产学习平台" />
                模拟考试
              </div>
              <div :class="tabIndex == 9 ? 'optionBox active' : 'optionBox'" @click="nav(9)">
                <img v-if="tabIndex == 9" src="../../assets/images/ct1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/ct.png" alt="安全生产学习平台" />
                错题库&emsp;
              </div>
              <!-- <div :class="tabIndex == 5 ? 'optionBox active' : 'optionBox'" @click="nav(5)">
                <img v-if="tabIndex == 5" src="../../assets/images/chankan1.png" alt="安全生产学习平台" />
                <img v-else src="../../assets/images/chakan.png" alt="安全生产学习平台" />
                证书查看
              </div>

              <div :class="tabIndex == 6? 'optionBox active' : 'optionBox'"
                   @click="nav(6)">
                <img v-if="tabIndex ==6"
                     src="../../assets/images/zsslh.png"
                     alt="安全生产学习平台">
                <img v-else
                     src="../../assets/images/zssl.png"
                     alt="安全生产学习平台">
                证书申领
              </div>

              <div :class="tabIndex == 2 ? 'optionBox active' : 'optionBox'"allClassesisMember
                   @click="nav(2)">
                <img v-if="tabIndex == 2"
                     src="../../assets/images/suoyou1.png"
                     alt="安全生产学习平台">
                <img v-else
                     src="../../assets/images/suoyou.png"
                     alt="安全生产学习平台">
              会员权益 
              </div> -->
            </div>
          </div>

          <div class="rightBox">
            <schedule v-if="tabIndex == 1" :tabIndex="tabIndex" @goUser="goUser" @update:tabIndex="tabIndex = $event"></schedule>
            <allClasses v-if="tabIndex == 2" :parentData="isMember"></allClasses>
            <order v-if="tabIndex == 3"></order>
            <account v-if="tabIndex == 4" :avatar.sync="userAvatar"></account>
            <certView v-if="tabIndex == 5"></certView>
            <application v-if="tabIndex == 6"></application>
            <questionBankPractice v-if="tabIndex == 7"></questionBankPractice>
            <zypx v-if="tabIndex == 8"></zypx>
            <examDetail v-if="tabIndex == 9"></examDetail>
            <mnExamDetail v-if="tabIndex == 10"></mnExamDetail>
          </div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
    <!-- <flotRight/> -->
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import schedule from './component/studySchedule.vue';
import allClasses from './component/allClasses.vue';
import order from './component/orderManagement.vue';
import account from './component/account.vue';
import certView from './component/certificateView.vue';
import application from './component/application.vue';
import questionBankPractice from './component/questionBankPractice.vue';
import examDetail from './component/examDetail.vue';
import mnExamDetail from './component/mnExamDetail.vue';
import zypx from './component/zypx.vue';
import { mapMutations } from 'vuex';
import { checkUserQuiz, checkToken, getUserInfo, getUserDetail } from '@/api/study.js';
import flotRight from '@/views/component/flotRight.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    schedule,
    allClasses,
    order,
    account,
    certView,
    application,
    questionBankPractice,
    flotRight,
    zypx,
    examDetail,
    mnExamDetail
  },
  data() {
    // 这里存放数据
    return {
      tabIndex: 1,
      messageFromChild: {}, //
      urlInfo: {},
      examShow: false,
      isMember: '',
      userAvatar: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),

    eventName() {
      //提示未支付订单弹框
      this.nav(3);
    },
    goUser() {
      //提示去完善信息
      this.nav(4);
    },
    nav(id) {
      this.tabIndex = id;
      if (id == 2) {
        this.$router.push('/resourcesList');
      } else if (id == 7) {
        //  window.open(this.$router.resolve({ path: '/studyMain?tabIndex=7' }).href, '_blank');
        this.$router.push({ path: '/studyMain', query: { tabIndex: 7 } });
      } else if (id == 8) {
        this.$router.push({ path: '/studyMain', query: { tabIndex: 8 } });
      } else if (id == 3) {
        this.$router.push({ path: '/studyMain', query: { tabIndex: 3 } });
      } else if (id == 10) {
        // window.open(this.$router.resolve({ path: '/studyMain?tabIndex=10' }).href, '_blank');
        this.$router.push({ path: '/studyMain', query: { tabIndex: 10 } });
      } else if (id == 9) {
        this.tabIndex = 1;
        window.open(this.$router.resolve({ path: '/errorExam' }).href, '_blank');
      } else if (id == 4) {
        this.$router.push({ path: '/studyMain', query: { tabIndex: 4 } });
      } else if (id == 1) {
        this.$router.push({ path: '/studyMain' });
      }
    },
    //判断是否有考试
    checkUserQuizs() {
      checkUserQuiz({}).then(res => {
        console.log(res.data);
        if (res.data.data.result !== '00') {
          this.examShow = true;
        } else {
          this.examShow = false;
        }
      });
    },
    //去个人信息页
    handleInfo() {
      this.tabIndex = 4;
    },
    getList() {
      getUserDetail({}).then(res => {
        this.urlInfo = res.data.data;
        this.messageFromChild = res.data.data;
        this.userAvatar = this.messageFromChild.userphoto;
        // this.isMember = res.data.data.isMember;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    window.scrollTo(0, 0);

    if (this.$route.query.token) {
      checkToken({ token: this.$route.query.token }).then(res => {
        console.log(res.data.data.checkToken);
        //检测token能不能用，能用再存储
        if (res.data.data.checkToken) {
          // 拿到密钥存在本地存储
          this.updateToken(this.$route.query.token);
          //拿到密钥存在本地存储;
          localStorage.setItem('token', this.$route.query.token);
        }
        // this.checkUserQuizs();
      });
    } else {
      // this.checkUserQuizs();
    }
    if (this.$route.query.tabIndex) {
      this.tabIndex = this.$route.query.tabIndex;
    }
    if (this.$route.query.type == 'exam') {
      this.tabIndex = '9';
    }
    if (this.$route.query.type == 'moni') {
      this.tabIndex = '10';
    }
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log(1);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.center {
  display: flex;
  justify-content: center;
}
.w {
  width: 1400px;
  background: #f7f7f7;
  padding: 20px 0;
  font-family: Regular;
  .content {
    display: flex;
    justify-content: space-between;
    .leftBox {
      width: 200px;
      .photoBox {
        width: 200px;
        height: 190px;
        background: #ffffff;
        border-radius: 6px;
        padding-top: 19px;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        .text {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          width: 100px;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .yue {
          margin-top: 19px;
          font-weight: bold;
          font-size: 14px;
          color: #ff8000;
          width: 164px;
          height: 42px;
          background: #fff3e6;
          border-radius: 21px;
          text-align: center;
          line-height: 42px;
        }
      }

      .tabBox {
        margin-top: 12px;
        width: 200px;
        background: #ffffff;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 36px 18px 20px 22px;
        font-size: 16px;
        .optionBox {
          width: 164px;
          height: 50px;
          border-radius: 6px;
          line-height: 50px;
          margin-bottom: 20px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
            margin-right: 5px;
          }
        }
        .active {
          color: #ffffff !important;
          background: #2878ff;
        }
      }
    }

    .rightBox {
      width: 1170px;
      min-height: 748px;
    }
  }
}
.btn_info {
  width: 164px;
  height: 36px;
  background: rgba(49, 114, 246, 0.1);
  border-radius: 21px 21px 21px 21px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #3172f6;
  line-height: 36px;
  text-align: center;
  font-style: normal;
  text-decoration-line: underline;
  margin-top: 13px;
  cursor: pointer;
}
</style>
